import { render, staticRenderFns } from "./days.vue?vue&type=template&id=197ed458&"
import script from "./days.vue?vue&type=script&lang=js&"
export * from "./days.vue?vue&type=script&lang=js&"
import style0 from "./days.vue?vue&type=style&index=0&id=197ed458&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports